export default function IArrowRight1({ width = 8, height = 8, color = "#040704", ...props }) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 8 8"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.17678 3.82322C7.27441 3.92085 7.27441 4.07914 7.17678 4.17677L4.51011 6.84344C4.41248 6.94107 4.25419 6.94107 4.15656 6.84344C4.05893 6.74581 4.05893 6.58752 4.15656 6.48988L6.64645 3.99999L4.15656 1.5101C4.05893 1.41247 4.05893 1.25418 4.15656 1.15655C4.25419 1.05892 4.41248 1.05892 4.51011 1.15655L7.17678 3.82322Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 3.99999C0.75 4.13807 0.861929 4.24999 1 4.24999H6.66667V3.74999H1C0.861929 3.74999 0.75 3.86192 0.75 3.99999Z"
        fill={color}
      />
    </svg>
  );
}
